// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609280904/js/" + chunkId + "." + {"44":"75deb67b","225":"da9ceeff","481":"c5bbd290","486":"1bc35811","770":"2e6e8450"}[chunkId] + ".0.4532449398063316.chunk.js";
};